// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.location-card {
  --bs-card-spacer-y: 2rem;
  --bs-card-spacer-x: 2rem;
  border: 1px solid #e0e0e0;
  border-radius: 1.025rem;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  animation: cardFadeSlideIn 0.6s ease;
}
@keyframes cardFadeSlideIn {
  from {
    opacity: 0;
    transform: translateY(1rem);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
.location-card > .location-header {
  border-radius: 1.025rem 1.025rem 0 0;
}
.location-card .LoadingBlur {
  border-radius: 1.025rem;
}`, "",{"version":3,"sources":["webpack://./src/features/DriveTimeTool/components/LocationCard/styles.scss"],"names":[],"mappings":"AAAA;EACE,wBAAA;EACA,wBAAA;EAEA,yBAAA;EACA,uBAAA;EACA,wCAAA;EACA,oCAAA;AAAF;AAEE;EACE;IACE,UAAA;IACA,2BAAA;EAAJ;EAEE;IACE,UAAA;IACA,wBAAA;EAAJ;AACF;AAEE;EACE,oCAAA;AAAJ;AAEE;EACE,uBAAA;AAAJ","sourcesContent":[".location-card {\n  --bs-card-spacer-y: 2rem;\n  --bs-card-spacer-x: 2rem;\n\n  border: 1px solid #e0e0e0;\n  border-radius: 1.025rem;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  animation: cardFadeSlideIn 0.6s ease;\n\n  @keyframes cardFadeSlideIn {\n    from {\n      opacity: 0;\n      transform: translateY(1rem);\n    }\n    to {\n      opacity: 1;\n      transform: translateY(0);\n    }\n  }\n  > .location-header {\n    border-radius: 1.025rem 1.025rem 0 0;\n  }\n  .LoadingBlur {\n    border-radius: 1.025rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
